import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEn from "./locales/en/translation.json";
import translationEs from "./locales/es/translation.json";
import translationFr from "./locales/fr/translation.json";
import translationDe from "./locales/de/translation.json";

i18n
  .use(initReactI18next)
  .init({
    debug: false,

    fallbackLng: "en",

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      es: {
        translations: translationEs,
      },
      fr: {
        translations: translationFr,
      },
      de: {
        translations: translationDe,
      },
    },

    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;
